export const updateVideos = (payload) => {
    return {
        type: 'videos/update',
        payload
    }
}